import { render, staticRenderFns } from "./Designers.vue?vue&type=template&id=138daece"
import script from "./Designers.vue?vue&type=script&lang=js"
export * from "./Designers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports